import axios from "axios";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { _appName, _clientLogo, _clientName, _serverUrl2 } from "../../../config";
import { setUserInfo } from "../../../Redux/Slices/userSlice";
import * as alerts from "../../../Utils/Alerts";
import { setCookieInDays } from "../../../Utils/Cookies";
import "./LoginPage.css";

export default function LoginPage() {
  const [isSmsConfirmation, setIsSmsConfirmation] = useState(false);
  const [smsId, setsmsId] = useState(false);
  const dispatch = useDispatch();

  const handleResponseError = (err) => {
    const msg = err.response?.data?.error || "Bir Hata oluştu";
    alerts.failed("Hata Oluştu. " + msg);
  };

  const onClickResendCode = async () => {
    const username = document.getElementById("floatingInput").value;
    const password = document.getElementById("floatingPassword").value;
    const loading = alerts.loading();

    try {
      await axios.post(_serverUrl2 + "/user/login2", {
        id: username,
        pw: password,
      });
    } catch (err) {
      handleResponseError(err);
    } finally {
      loading.close();
    }
  };

  const onSubmitLoginForm = async (e) => {
    e.preventDefault();
    const loading = alerts.loading();
    const { floatingInput, floatingPassword, floatingSms } = e.target;
    const response = await fetch('https://geolocation-db.com/json/');
    const data = await response.json();


    try {
         const response = await fetch('https://geolocation-db.com/json/');
    const data = await response.json();
    
      const res = await axios.post(_serverUrl2 + "/login", {
        id: floatingInput.value,
        pw: floatingPassword.value,
        smsCode: floatingSms?.value,
        ...(smsId != null ? { smsId } : {}),
        ip:data.IPv4
      });

      if (res.data.status === false) {
        alerts.failed("Kullanıcı adı veya şifre hatalı.");
      } else if (res.data.sms) {
        setIsSmsConfirmation(true);
        setsmsId(res.data.sms)
        
      } else {
        if (res.data.rows.length === 0) {
          alerts.failed("Kullanıcı adı veya şifre hatalı.");
          return;
        }
        const user = res.data.rows[0];
        const { common } = axios.defaults.headers
        await axios.post(_serverUrl2 + "/user/addToken", { token: res.data.token, id: user.id });
        common["plaka"] = user.plaka_kod;
        common["Authorization"] = "Bearer " + res.data.token;
        common["id"] = user.id;
        setCookieInDays("token", res.data.token, 1);
        dispatch(setUserInfo(user));
      }
    } catch (err) {
      handleResponseError(err);
    } finally {
      loading.close();
    }
  };

  return (
    <div className="container-fluid pageStyle">
      <div className="row justify-content-center">
        <center>
          <img src={_clientLogo} alt={_clientName} className="client-logo" />
          <div className="card login-card">
            <form className="login-form" onSubmit={onSubmitLoginForm}>
              <div className="col-12 app-name">
                {_appName}
              </div>
              <div className="col-12 form-group">
                <div className="form-floating mb-3">
                  <input type="text" className="form-control" id="floatingInput" placeholder="Kullanıcı Adı" disabled={isSmsConfirmation} />
                  <label htmlFor="floatingInput">Kullanıcı Adı</label>
                </div>
              </div>
              <div className="col-12 form-group">
                <div className="form-floating">
                  <input type="password" className="form-control" id="floatingPassword" placeholder="Parola" disabled={isSmsConfirmation} />
                  <label htmlFor="floatingPassword">Parola</label>
                </div>
              </div>
              {isSmsConfirmation && (
                <>
                  <div className="col-9 form-group">
                    <div className="form-floating">
                      <input type="text" className="form-control" id="floatingSms" placeholder="SMS Kod" />
                      <label htmlFor="floatingSms">SMS Kod</label>
                    </div>
                  </div>
                  <div className="col-3 form-group">
                    <button className="blueBtn" type="button" onClick={onClickResendCode}>
                      <i className="fas fa-sync-alt"></i>
                    </button>
                  </div>
                </>
              )}
              <div className="col-12 form-group">
                <button className="blueBtn" type="submit">
                  <b>Giriş</b>
                </button>
              </div>
            </form>
          </div>
        </center>
      </div>
    </div>
  );
}
